import { mainSiteUrl } from '@/mocks/categories';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setStatusMessage('Grazie per l\'iscrizione!');
      setEmail('');
      return;
    }
    if (!email.trim()) return;

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('source', 'itaobuyspread-footer');

      const response = await fetch('https://readdy.ai/api/form/d9b01qkngs93pt5sh6i0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, source: 'itaobuyspread-footer' }).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMessage('Grazie per l\'iscrizione! Controlla la tua email.');
        setEmail('');
      } else if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
        setStatus('error');
        setStatusMessage(serverMsg || 'Si è verificato un errore. Riprova più tardi.');
      } else {
        setStatus('error');
        setStatusMessage(serverMsg || 'Si è verificato un errore. Riprova più tardi.');
      }
    } catch {
      setStatus('error');
      setStatusMessage('Errore di rete. Riprova più tardi.');
    }
  };

  return (
    <footer className="bg-accent-900 text-white">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <div className="py-16 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <a href="/" className="font-heading text-2xl font-semibold text-white tracking-tight inline-block mb-6">
              Itaobuy<span className="italic font-normal text-accent-300">Spreadsheet</span>
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent-300 ml-1 align-super"></span>
            </a>

            <form onSubmit={handleSubscribe} className="mb-6" data-readdy-form="d9b01qkngs93pt5sh6i0">
              <div className="flex items-stretch max-w-sm">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="La tua email"
                  className="flex-1 px-4 py-3 bg-transparent border border-white/20 rounded-l-full text-sm text-white placeholder-white/40 focus:outline-none focus:border-white/50"
                  required
                />
                <button
                  type="submit"
                  className="px-5 py-3 bg-white/10 border border-white/20 border-l-0 rounded-r-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-notification-line text-white w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
              <div className="hp-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
            </form>

            {status !== 'idle' && (
              <p className={`text-sm mb-4 ${status === 'success' ? 'text-green-300' : 'text-red-300'}`}>
                {statusMessage}
              </p>
            )}

            <p className="text-white/60 text-lg md:text-xl font-heading italic leading-snug">
              Resta aggiornato sulle novità
            </p>
            <p className="text-white/60 text-lg md:text-xl font-heading italic leading-snug">
              di Itaobuy Spreadsheet
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Naviga</h4>
              <div className="flex flex-col gap-2.5">
                <a href="/" className="text-white/60 text-sm hover:text-white transition-colors">Home</a>
                <a href="/itaobuy-spreadsheet-guida" className="text-white/60 text-sm hover:text-white transition-colors">Guida</a>
                <a href="/itaobuy-spreadsheet-guida-acquisti" className="text-white/60 text-sm hover:text-white transition-colors">Guida Acquisti</a>
                <a href="/itaobuy-spreadsheet-recensione" className="text-white/60 text-sm hover:text-white transition-colors">Recensioni</a>
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Risorse</h4>
              <div className="flex flex-col gap-2.5">
                <a href="/itaobuy-spreadsheet-sicurezza" className="text-white/60 text-sm hover:text-white transition-colors">Sicurezza</a>
                <a href="/itaobuy-spreadsheet-confronto" className="text-white/60 text-sm hover:text-white transition-colors">Confronti</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Shop</a>
                <a href="#articoli" className="text-white/60 text-sm hover:text-white transition-colors">Articoli</a>
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Link</h4>
              <div className="flex flex-col gap-2.5">
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Itaobuy Sheet</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Buy It Now</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Prodotti</a>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors">Contatti</a>
              </div>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Legale</h4>
              <div className="flex flex-col gap-2.5">
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Cookie Policy</a>
                <a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Termini</a>
              </div>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-3">
            {['ri-facebook-line', 'ri-twitter-x-line', 'ri-instagram-line', 'ri-linkedin-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-colors"
              >
                <i className={`${icon} w-3.5 h-3.5 flex items-center justify-center`}></i>
              </a>
            ))}
          </div>
          <a href="#" className="text-white/40 text-xs hover:text-white/60 transition-colors">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}